var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing__faq" },
    _vm._l(_vm.faq, function(item, i) {
      return _c("landing-expand-panel", {
        key: i,
        attrs: { item: item, active: _vm.activeQuestion === i },
        on: {
          click: function(e) {
            return _vm.setActiveQuestion(e, i)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }